import PageHero from "../components/PageHero";
import SectionIntro from "../components/SectionIntro";
import Button from "../components/Button";
import { FlaskConical, GraduationCap, Users } from "lucide-react";
import { homeImages } from "../data/siteData";

const serviceAreas = [
  {
    title: "Scientific & Research Consulting",
    description:
      "Grant writing, scientific writing, clinical research strategy, and program management for research, education, and workforce initiatives.",
    icon: FlaskConical,
    path: "/services/scientific-consulting",
  },
  {
    title: "STEM Education & Workforce Development",
    description:
      "Education, training, mentorship, and real-world exposure to build a diverse, skilled, and job-ready clinical research workforce.",
    icon: GraduationCap,
    path: "/services/stem-workforce",
  },
  {
    title: "Mentorship & Career Development",
    description:
      "One-on-one mentorship, resume and interview preparation, and career-pathway guidance for emerging STEM and healthcare professionals.",
    icon: Users,
    path: "/services/mentorship",
  },
];

export default function ServicesOverviewPage() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Scientific, education, and career-development services."
        description="BrainTorch™ Bio supports research, education, and workforce initiatives across three connected service areas."
        image={homeImages.services}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Explore Our Services"
          title="Three connected service areas."
          text="Select an area below to learn more about how BrainTorch™ Bio supports organizations and individuals."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {serviceAreas.map((area) => {
            const Icon = area.icon;
            return (
              <article key={area.title} className="info-card">
                <div className="info-card__icon"><Icon size={28} /></div>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
                <div className="top-gap-sm">
                  <Button to={area.path} variant="link">Learn more →</Button>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Not sure which service is the right fit?</h2>
            <p>Reach out and we’ll help you identify the right starting point for your goals.</p>
          </div>
          <div className="button-row">
            <Button to="/contact#contact-form" variant="teal">Contact Us</Button>
          </div>
        </div>
      </section>
    </>
  );
}
